var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMagnifier(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icon/Search ") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u9875\\u9762-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "\\u753B\\u677F",
    transform: "translate(-58.000000, -50.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icon/Search-",
    transform: "translate(58.000000, 50.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "\\u77E9\\u5F62",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.62290353,11.2807643 C5.59612946,9.25873202 6.65013058,7.37601336 8.38787487,6.34181022 C10.1256192,5.30760708 12.2831019,5.27903952 14.0476202,6.26686866 C15.8121386,7.2546978 16.9156201,9.1088489 16.9423942,11.1308812 C16.9837832,14.2566722 14.4833814,16.8241789 11.3575904,16.865568 C8.23179941,16.906957 5.66429265,14.4065553 5.62290353,11.2807643 L5.62290353,11.2807643 Z M19.7052837,18.5640222 L16.945047,15.8024591 C18.1490581,14.2983517 18.7058938,12.3773776 18.4929397,10.4625323 C18.2799856,8.54768703 17.3147043,6.7959909 15.8096493,5.59316458 C12.6763637,3.08842739 8.10596923,3.59730462 5.60035474,6.72988868 C3.27781667,9.6213382 3.50719676,13.7982633 6.13238741,16.4180032 C8.75757807,19.0377432 12.9349709,19.2584412 15.8215868,16.9298984 L18.5804971,19.6888087 C18.8854311,19.9949738 19.3789611,20.0018719 19.6923329,19.7043488 C20.0057046,19.4068258 20.0244063,18.913602 19.7344644,18.593203 L19.7052837,18.5640222 L19.7052837,18.5640222 Z",
    id: "\\u5F62\\u72B6",
    fillOpacity: 0.4,
    fill: "#54587E",
    fillRule: "nonzero"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMagnifier);
export default __webpack_public_path__ + "static/media/magnifier.0ef1f9660033a8e988208ad7aa670908.svg";
export { ForwardRef as ReactComponent };